import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../common/services/firebase";

export const renameExercise = async (exerciseId: string, name: string): Promise<void> => {
	await updateDoc(doc(db, "exercises", exerciseId), {
		name,
	});
};
